import React, {useEffect, useState} from 'react'
import Applications from "../../datas/Applications.json"
import RippleButton from '../../../../components/Buttons/RippleButton'
import next from '../../../assets/icons/back-svgrepo-com.svg'
import userPic from "../../../assets/users/bonnie-green-2x.png"
import HomeCard from "../../../trainer/components/HomeCard"
import Dropdown from "../../../../components/Dropdown/Dropdown"
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { END_POINT as api, END_POINT, JOB_API_END_POINT } from '../../../../utils/constant'
import ImageWithFallback from '../../../components/ImageWithFallback'
import StatusBadge from "../../../components/StatusBadge"
import {isExpired} from "../../../../utils/Func"

const Home = () => {

      const [offers, setOffers] = useState([])
      const [loading, setloading] = useState(true)
    const [tasks, setTasks] = useState(Applications)
    const dispatch = useDispatch();
    const {user} = useSelector(store=>store.user);

    // useEffect(() => {
    //   // Fetch data from JSON or API
    // //   axios.get('../../datas/Applications.json')
    // //     .then(response => {
    // //       setTasks(response.data)
    // //     })
    // //     .catch(error => {
    // //       console.error("Error fetching tasks data:", error);
    // //     })
    // setTasks(Applications)
    // }, [])

    const [summary, setSummary] = useState({
      totalCandidates: 4,
      totalOffers: 3,
      totalApplications: 5,
    });
    
    useEffect(() => {
  

        //   axios.get('../../datas/Applications.json',{ 
        //     "user_id" : user?.id
        //   })
        // .then(response => {
        //   setTasks(response.data)
        // })
        // .catch(error => {
        //   console.error("Error fetching tasks data:", error);
        // })

        const fetchPostData = async () => {
       
          await axios.get(`${JOB_API_END_POINT}/recruiter/all?user_id=2`)
          .then(response => {
            setOffers(response.data)
            setloading(false)
          })
          .catch(error => {
            setloading(false)
          })
        }

        axios.post(api+'/recruiter/summary/2')
          .then(response => {
            setSummary(response.data);
          })
          .catch(error => {
            console.error("Error fetching summary data:", error);
          });

        fetchPostData()

    }, []);
  

  return (
    <div className=' min-h-full w-full pr-6 xl:pr-40 pl-6 text-primary-black py-10'>
        <div className="space-y-2 mb-4 text-start">
        <h1 className="text-xl font-semibold">Bonjour, {user?.nom || "Cher Utilisateur"}</h1>
        <p className='text-sm text-primary-text '>Voici un résumé de votre activité.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <HomeCard baseColor="bg-[#f3ffc9]" title="Total de candidatures" count={summary.totalApplications} date="Oct 16, 2024" />
          <HomeCard baseColor="bg-primary-green" title="Total de candidats" count={summary.totalCandidates} date="Oct 16, 2024" />
          <HomeCard baseColor="bg-primary-purple" title="Total d'offres" count={summary.totalOffers} date="Oct 16, 2024" />
        </div>

        <div className="bg-primary-purple bg-gradient-to-r from-[#fadcff] to-[#e2dceb] w-full rounded-md py-4 px-6  flex justify-between items-center" >
            <div className="flex gap-4">
              <ImageWithFallback src={END_POINT+ "/storage"+ user.photo} alt="" className='bg-white border-2 border-purple-200 rounded-full w-14 h-14' defaultType='user' />
            <div className="flex flex-col justify-between text-start">
                <p className='text-lg font-bold'>Votre profil est incomplète</p>
                <p className='text-sm'>Editer votre profil et publier des offres.</p>
            </div>
            </div>
            <button className="bg-white font-semibold flex items-center gap-x-2 rounded-md shadow py-2 px-6 text-sm">
                Editer
                <img src={next} alt="" className='w-4 rotate-180' />
            </button>
            
        </div>

        <div className=" w-full">
      <div className="  py-4 ">
        <div className="flex items-center justify-between">
          <p className="text-base sm:text-lg md:text-xl lg:text-lg font-bold text-gray-800">Historique des candidatures</p>
          <button className=" font-semibold flex items-center gap-x-2 rounded-md  py-2 text-sm">
                Voir tout
                <img src={next} alt="" className='w-4 rotate-180' />
            </button>
        </div>
      </div>
      
      <div className="bg-white py-4  text-sm">
        <div className=" overflow-x-auto  pb-28">
          <table className="w-full ">
            <thead>
              <tr className="text-left bg-neutral-100 py-4 rounded-sm">
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Titre</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Date de candidature</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Etat</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm ">Action</th>
              </tr>
            </thead>
            <tbody>
              {offers.map(task => (
                <tr key={task.id} className=" border-b border-gray-100 rounded ">
                  <td className="pl-5 py-3">
                    <div className="flex items-center gap-2">
                        <div className="flex flex-col justify-between">
                            
                      <p className="text-base font-medium mr-2">{task.job_title}</p>
                      <div className="flex gap-2 text-xs">
                        Aprivo France
                      </div>
                        </div>
                    </div>
                  </td>
                  <td className="pl-5  justify-start flex items-center">
                   {/* {isExpired(task?.appli_end_at) ? "Expiré" : "Disponible"} */}
                   <div className={isExpired(task?.appli_end_at) ? 
            'flex items-center gap-1 rounded-full border text-sm py-1 px-2 font-normal border-[#fd5d60] bg-[#fd5d60]/5 text-[#fd5d60] bg-[#e5daff]'
            :
            'flex items-center gap-1 rounded-full border text-sm py-1 px-2 font-normal border-[#3700c3] bg-[#3700c3]/5 text-[#3700c3] '}>
            <span className={
              isExpired(task?.appli_end_at) ? 
              'w-2.5 h-2.5 rounded-full bg-[#fd5d60]'
            :
            'w-2.5 h-2.5 rounded-full bg-[#3700c3]'}>
            </span> {isExpired(task?.appli_end_at) ? "Expirée" : "Disponible"}
            </div>
                  </td>
                  <td className="pl-5">
                    <p className="text-sm leading-none  text-start flex gap-1 items-center text-primary-text">
                  
                    {task?.applications_count || 0} Candidats</p>
                  </td>
                  <td className="pl-5 flex items-center">
                    <RippleButton className='whitespace-nowrap w-40 bg-primary-green text-green-900 font-semibold hover:bg-primary-green/80' path={"/mira-recruteur/offre/"+task?.id+"/candidature/2"} >Voir candidature</RippleButton>
                    <Dropdown/>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
        </div>
        {/* <HomeCard></HomeCard> */}
    </div>
  )
}

export default Home